import { lazy } from 'react';
import type { ComponentType } from 'react';
import type { ToolId } from '../types';

type ToolComponent = ComponentType;

export const toolComponents: Record<ToolId, React.LazyExoticComponent<ToolComponent>> = {
  'json-formatter': lazy(() => import('./JsonFormatter')),
  base64: lazy(() => import('./Base64Tool')),
  'url-encoder': lazy(() => import('./UrlEncoder')),
  'jwt-debugger': lazy(() => import('./JwtDebugger')),
  'regex-tester': lazy(() => import('./RegexTester')),
  'cron-parser': lazy(() => import('./CronParser')),
  'sql-formatter': lazy(() => import('./SqlFormatter')),
  'markdown-previewer': lazy(() => import('./MarkdownPreviewer')),
  'password-generator': lazy(() => import('./PasswordGenerator')),
  'hash-generator': lazy(() => import('./HashGenerator')),
  'color-converter': lazy(() => import('./ColorConverter')),
  'unit-converter': lazy(() => import('./UnitConverter')),
  'lorem-ipsum': lazy(() => import('./LoremIpsum')),
  'diff-checker': lazy(() => import('./DiffChecker')),
  'code-minifier': lazy(() => import('./CodeMinifier')),
  'ci-workflow-generator': lazy(() => import('./ApiTool')),
  'terraform-module-generator': lazy(() => import('./ApiTool')),
  'terraform-validator': lazy(() => import('./ApiTool')),
  'ansible-playbook-generator': lazy(() => import('./ApiTool')),
  'ssh-hardening-generator': lazy(() => import('./ApiTool')),
  'docker-compose-generator': lazy(() => import('./ApiTool')),
  'kubernetes-manifest-generator': lazy(() => import('./ApiTool')),
  'helm-values-generator': lazy(() => import('./ApiTool')),
  'gitlab-ci-generator': lazy(() => import('./ApiTool')),
  'circleci-config-generator': lazy(() => import('./ApiTool')),
  'argocd-application-generator': lazy(() => import('./ApiTool')),
};
